import { shortcuts } from './styles';

const ShortcutsInfo = () => {
	return (
		<div className={shortcuts}>
			Press <strong>Shift+Option+F</strong> for auto indent; <strong>Ctrl+Space</strong> for
			autocomplete
		</div>
	);
};

export default ShortcutsInfo;
